import { render } from "./FleetSummary.vue?vue&type=template&id=71c2b038&scoped=true"
import script from "./FleetSummary.vue?vue&type=script&lang=js"
export * from "./FleetSummary.vue?vue&type=script&lang=js"

import "./FleetSummary.vue?vue&type=style&index=0&id=71c2b038&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c2b038"]])

export default __exports__